module.exports = __webpack_public_path__ + "static/media/service2.bf61dbe1.webp";